export class serviceAppointmentTimeSlotModel {
  practiceCode: any;
  providerCode: any;
  locationCode: any;
  reasonID: any;
  date: any;
  patientAccount: any;
  patientTimeZone: any;
  isTelehealth: any;
  isFirstAvailable: any;
  // Adding for DateSlots Range Request
  startDate: any;
  endDate: any;
}
export class reschedulePatientAppointModel {
  appointment_Id: any;
  provider_Code: any;
  patient_Account: any;
  reason_Id: any;
  location_Id: any;
  practice_Code: any;
  appointment_Date: any;
  time_From: any;
  patTimeZone: any;
  startDate: any;
  endDate: any;
}
export class appointmentTimeSlotModel {
  availableDate: string;
  availableSlot: string;
  isInsurance: boolean;
  appointmentCharges: string;
  appointmentChargesWithSign: string;
}
export class ProviderModel {
  providerCode: string;
  providerName: string;
  providerPrefix: string;
}
export class appointmentReasonModel {
  reasonId: string;
  reasonName: string;
}
export class AvailableSlotsModule {
  day: any;
  fullDate: any;
  isDisable: any;
  month: any;
  date: any;
  providerName: any;
  slotsAvailable: any;
}
export class LocationModel {
  locationCode: string;
  locationName: string;
}
export class scheduleAppointmentModel {
  provider: ProviderModel;
  location: LocationModel;
  reason: appointmentReasonModel;
  appointmentSlots: appointmentTimeSlotModel[];
  appointmentSlotsAvailable: AvailableSlotsModule[];
  isInsurance: boolean;
  appointmentCharges: string;

}
export class addAppointmentRequest {
  practice_code: any;
  patient_Account: any;
  provider_Code: any;
  location_Code: any;
  app_date: any;
  first_Name: any;
  last_Name: any;
  dateofBrith: any;
  phone: any;
  app_ReasonId: any;
  time_From: any;
  client_IP: any;
  email: any;
  teleMedicine_Session: any;
  patTimeZone: any;
  isConsentForm: any;
  is_WaitList: any;
  appSource: any;
} 
